"use strict";

exports.__esModule = true;
exports.createEChartProps = exports.AggsMetricChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _echartsForReact = _interopRequireDefault(require("echarts-for-react"));
require("echarts/theme/v5");
var _theme = require("../../../Echarts/theme");
var _dataFormatter = require("../dataFormatter");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _styledComponents = require("styled-components");
var _excluded = ["bin"]; // The official v5 theme keeps the legacy look on echarts 6; the modern UI
// draws with the "vimana" theme registered in Echarts/theme.
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var AggsMetricChart = exports.AggsMetricChart = function AggsMetricChart(props) {
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var echartsProps = props.echartsProps,
    width = props.width,
    height = props.height,
    displayProps = props.displayProps,
    timePeriod = props.timePeriod;
  var weeks = _momentTimezone["default"].unix(timePeriod.interval.endMillis).diff(_momentTimezone["default"].unix(timePeriod.interval.startMillis), "week");
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "grouped-bar-chart-testid"
  }, /*#__PURE__*/_react["default"].createElement(_echartsForReact["default"], {
    theme: theme.uiModern ? _theme.ECHARTS_THEME : "v5",
    option: createEChartProps(echartsProps, displayProps, weeks, theme),
    notMerge: true,
    lazyUpdate: false,
    style: {
      height: height - 26,
      width: width
    }
  }));
};
var createEChartProps = exports.createEChartProps = function createEChartProps(eChartProps, displayProps, weeks, theme) {
  var series = eChartProps.series,
    axis = eChartProps.axis,
    legend = eChartProps.legend,
    metricName = eChartProps.metricName,
    timeBinName = eChartProps.timeBinName,
    yAxisMaxVal = eChartProps.yAxisMaxVal;
  var formattedSeries = series.map(function (it) {
    // eslint-disable-next-line no-unused-vars
    var bin = it.bin,
      rest = _objectWithoutPropertiesLoose(it, _excluded);
    return rest;
  });
  return {
    dataZoom: [{
      id: "dataZoomX",
      type: "slider",
      xAxisIndex: [0],
      start: 0,
      end: weeks > 2 ? 10 : 80,
      rangeMode: "percent",
      filterMode: "filter",
      bottom: "7%",
      textStyle: {
        color: theme.ChartAxisTextColor
      }
    }],
    series: formattedSeries,
    tooltip: {
      show: displayProps.showChartTooltip,
      trigger: "item",
      axisPointer: {
        type: "shadow"
      },
      formatter: function formatter(params) {
        var unit = (0, _dataFormatter.isPercentageMetric)(metricName) ? "%" : (0, _dataFormatter.isMillis)(metricName) ? " hours" : " ";
        var colorSpan = function colorSpan(color) {
          return '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + color + '"></span>';
        };
        if (params.componentType !== "markPoint") {
          var rez = "<p style='text-align:center;'>" + params.name + "</p>";
          var xx = "<span style='text-align:left;'>" + colorSpan(params.color) + " " + params.seriesName + " " + "</span><span style='margin-left:1em;text-align:end;'> " + params.data + unit + "</span>";
          rez += xx;
          return rez;
        } else {
          var _rez = "<p style='text-align:center;'>" + params.data.xAxis + "</p>";
          var _xx = "<span style='text-align:left;'>" + params.name + " " + "</span><span style='margin-left:1em;text-align:end;'> " + params.value + unit + "</span>";
          _rez += _xx;
          return _rez;
        }
      }
    },
    legend: {
      data: legend,
      type: "scroll",
      top: "3%",
      width: "100%",
      show: displayProps.showLegends,
      textStyle: {
        fontSize: theme.uiModern ? 11 : 12,
        color: theme.ChartLegendTextColor
      },
      pageTextStyle: {
        color: theme.ChartLegendTextColor
      }
    },
    grid: {
      show: false
    },
    xAxis: {
      name: timeBinName,
      boundaryGap: true,
      gridIndex: 0,
      nameLocation: "end",
      type: "category",
      data: axis,
      position: "bottom",
      show: !displayProps.hideXAxis,
      nameTextStyle: 12,
      axisLabel: Object.assign({
        fontSize: theme.uiModern ? 10.5 : 12,
        align: "right",
        overflow: "break",
        show: !displayProps.hideXUnits,
        color: theme.ChartAxisTextColor
      }, theme.uiModern ? {
        fontFamily: theme.ChartFontFamilyMono
      } : {}),
      // Modern: a faint baseline instead of a drawn axis, and no tick marks.
      axisLine: Object.assign({
        show: true
      }, theme.uiModern ? {
        lineStyle: {
          color: theme.ChartGridColor
        }
      } : {}),
      axisTick: theme.uiModern ? {
        show: false
      } : {
        show: true,
        alignWithLabel: true,
        interval: "auto",
        inside: false,
        length: 5,
        lineStyle: {
          color: theme.TextColor,
          width: 1,
          type: "solid",
          shadowOffsetX: 0,
          shadowOffsetY: 0
        }
      }
    },
    yAxis: [{
      type: "value",
      max: yAxisMaxVal,
      splitLine: {
        show: true,
        lineStyle: {
          color: [theme.ChartGridColor]
        }
      },
      axisLabel: Object.assign({
        color: theme.ChartAxisTextColor
      }, theme.uiModern ? {
        fontFamily: theme.ChartFontFamilyMono,
        fontSize: 10.5
      } : {}, {
        formatter: (0, _dataFormatter.isPercentageMetric)(metricName) ? "{value} %" : (0, _dataFormatter.isMillis)(metricName) ? "{value} hours" : "{value}"
      }),
      axisLine: {
        show: !displayProps.hideYAxis,
        lineStyle: {
          color: theme.uiModern ? theme.ChartGridColor : theme.TextColor
        }
      },
      axisTick: {
        show: !theme.uiModern
      }
    }]
  };
};